/**
 * Game page — production PvP Roulette.
 * roomId from config (pvpRoomId). Data & subscription are managed by PvpRoomRoot.
 */

import { getRuntimeConfig } from "@/shared/config"
import { PvPRoomLayout } from "@/features/pvp-room"
import { useDemoModeStore } from "@/shared/store"
import { getUserIdFromToken } from "@/shared/api/auth"

export default function GamePage() {
  const config = getRuntimeConfig()
  const roomId = config.pvpRoomId ?? "default"
  // Demo override stays reactive; real play falls back to the auth token's user id.
  const demoCurrentUserId = useDemoModeStore((s) =>
    s.active ? s.config?.meUserId ?? null : null
  )
  const currentUserId = demoCurrentUserId ?? getUserIdFromToken()

  return (
    <div className="space-y-4">
      <PvPRoomLayout roomId={roomId} currentUserId={currentUserId} />
    </div>
  )
}
